import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import './BackButton.css';

// Routes where a global "go back" button should NOT appear (top-level landing / auth).
const HIDDEN_PATHS = ['/', '/login', '/workspace/login', '/auth/callback', '/auth/atozas/callback'];

function BackButton() {
  const navigate = useNavigate();
  const location = useLocation();

  if (HIDDEN_PATHS.includes(location.pathname)) {
    return null;
  }

  const handleBack = () => {
    // location.key === 'default' means this is the first entry in the history
    // stack (e.g. opened via a direct link), so there is nothing to go back to.
    if (location.key && location.key !== 'default') {
      navigate(-1);
    } else {
      navigate('/');
    }
  };

  return (
    <button
      type="button"
      className="global-back-btn"
      onClick={handleBack}
      aria-label="Go back"
      title="Go back"
    >
      <svg
        width="20"
        height="20"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2.2"
        strokeLinecap="round"
        strokeLinejoin="round"
        aria-hidden="true"
      >
        <path d="M15 18l-6-6 6-6" />
      </svg>
      <span className="global-back-btn__label">Back</span>
    </button>
  );
}

export default BackButton;
